import React from 'react';

const FisioSchedule = () => {
  return (
    <section className="py-16 bg-blue-50">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-4xl font-bold text-gray-800 mb-12">Nuestro Horario</h2>
        <div className="bg-white p-8 rounded-xl shadow-lg max-w-md mx-auto">
          <ul className="text-gray-700 text-lg space-y-4">
            <li className="flex justify-between items-center border-b pb-2">
              <span className="font-semibold">Lunes a Viernes:</span>
              <span>8:00 am - 2:00 pm</span>
            </li>
            <li className="flex justify-between items-center border-b pb-2">
              <span className="font-semibold">Lunes a Viernes:</span>
              <span>6:00 pm - 9:00 pm</span>
            </li>
            <li className="flex justify-between items-center">
              <span className="font-semibold">Sábado:</span>
              <span>9:00 am - 3:00 pm</span>
            </li>
          </ul>
          <p className="mt-6 text-blue-600 font-medium">¡Agenda tu cita y recupera tu movimiento!</p>
        </div>
      </div>
    </section>
  );
};

export default FisioSchedule;